// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      id="BaslerIcon__Logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 204"
      {...props}
    >
      <defs>
        <style>{".BaslerIcon__cls-1{fill:#000d6e}"}</style>
      </defs>
      <path
        className="BaslerIcon__cls-1"
        d="M307.71 57.5c-12.43 0-22.9 3.7-31.18 10.68V15.63h-36.42V175h33.58v-9.82c8.29 8.07 19.41 12.65 33.15 12.65 33.36 0 57.13-25.73 57.13-60.19S340.86 57.5 307.71 57.5Zm-6.1 88.31c-15.92 0-26.83-11.55-26.83-28.13 0-16.79 10.69-28.34 26.83-28.34 15.26 0 26.38 12 26.38 28.34s-11.12 28.13-26.38 28.13Zm164.85-73.7c-8.07-8.07-19-12.43-33.14-12.43-33.37 0-57.36 23.55-57.36 58s24 60.19 57.36 60.19c14.17 0 25.07-4.8 33.14-13.3V175h33.59V60.11h-33.59Zm-27.91 73.7c-15.48 0-26.39-11.77-26.39-28.13s11.13-28.34 26.39-28.34c15.92 0 26.6 11.55 26.6 28.34 0 16.58-10.68 28.13-26.6 28.13ZM524.06 175h36.42V15.63h-36.42ZM639.22 57.5c-36.63 0-62.8 25.73-62.8 60.18 0 34.24 26.17 60.19 62.8 60.19 36.86 0 63-26 63-60.19.03-34.45-26.14-60.18-63-60.18Zm.22 88.1c-15.92 0-26.39-11.78-26.39-27.92 0-16.57 10.47-27.91 26.39-27.91s26.17 11.34 26.17 27.7c0 16.53-10.47 28.13-26.17 28.13ZM736.8 0c-12.87 0-23.91 9.38-23.91 22.46s11 22.24 23.91 22.24 22.89-9.15 22.89-22.24S749.66 0 736.8 0Zm-18.32 175h36.42V60.11h-36.42Zm92-83.52c0-4.8 3.71-7.64 11.12-7.64 7.63 0 13.09 3.71 15.7 10.91L867.42 83c-4.58-16.14-21.59-25.51-45.14-25.51C793.27 57.5 775 71 775 93.26c0 39.47 60 30.75 60 48.85 0 5.23-4.36 8.5-12.64 8.5-11.78 0-19.41-5.45-22.46-15l-30.1 11.55c6.76 20.07 25.3 30.75 51.25 30.75 30.31 0 49.5-14.39 49.5-38.16-.08-42.35-60.05-31.88-60.05-48.23ZM1000 115.29c0-28.35-22.24-58-59.75-58-33.15 0-59.75 27.26-59.75 60.4 0 34.24 24 60.19 61.93 60.19 25 0 39.83-9.65 48.7-20.65l-20.94-21c-6.54 8.1-13.8 12-26.67 12-13.74 0-24-7-27.7-19.84h83.31a93 93 0 0 0 .87-13.1Zm-84.61-9.6c3.05-14 12.43-21.15 25.73-21.15s22 8.07 25.08 21.15ZM2.52 97.92a8.59 8.59 0 0 0 0 12.16l91.4 91.4a8.59 8.59 0 0 0 12.16 0l50.72-50.72-30.87-30.87L100 145.81 58.19 104 100 62.19l72.69 72.68 24.79-24.79a8.59 8.59 0 0 0 0-12.16l-91.4-91.4a8.59 8.59 0 0 0-12.16 0Z"
      />
    </svg>
  );
};

const BaslerIcon = Icon;
export default BaslerIcon;
